import React, { ReactNode } from 'react';

type ModalTitleVariants = 'primary' | 'subtitle' | 'small';

export interface ModalTitleProps {
  children?: ReactNode;
  size?: 'lg' | 'md';
  variant: ModalTitleVariants;
}

export const ModalTitle = ({ children, size, variant }: ModalTitleProps) => {
  /* Checking for missing required props */
  // if (!variant)
  //   throw new Error(
  //     `You need to pass a prop called "variant" of type string to the Modal Title component. To learn more about the list of required props for the
  //     Modal Title component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/typography-modal-title`
  //   );
  // if (!children)
  //   throw new Error(
  //     `You need to pass a prop called "children" of type ReactNode to the Modal Title component. To learn more about the list of required props for the
  //     Modal Title component go to Maverick documentation at: https://thryvlabs-maverick.netlify.app/?path=/docs/typography-modal-title`
  //   );
  /* Checking for missing required props */
  const renderModalTitlePrimary = variant === 'primary' && !size && (
    <h2 className="text-modal-title-h2 font-montserrat font-semibold text-thryv-black-500 leading-modal-title-primary capitalize">
      {children}
    </h2>
  );

  const renderSmallModatTitle = variant === 'small' && !size && (
    <h6 className="text-modal-title-sm font-montserrat font-semibold text-thryv-black-500 capitalize">
      {children}
    </h6>
  );

  const renderModalSubtitleLG = variant === 'subtitle' && size === 'lg' && (
    <h6 className="text-modal-subtitle-lg font-open-sans font-semibold text-thryv-black-500 capitalize mb-[10px]">
      {children}
    </h6>
  );

  const renderModalSubtitleMD = variant === 'subtitle' && size === 'md' && (
    <h6 className="text-modal-subtitle-md font-open-sans font-semibold text-thryv-black-500 capitalize mb-[14px]">
      {children}
    </h6>
  );

  return (
    <>
      {renderModalTitlePrimary}
      {renderSmallModatTitle}
      {renderModalSubtitleLG}
      {renderModalSubtitleMD}
    </>
  );
};
